import React from 'react';
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

interface IProps {
    onResetFilters: () => void;
}

const StyledFilterResetBtn = styled.button`
    background: var(${GLOBAL_STYLE_CONFIG.variable('clear-button', 'bg-color')}, transparent);
    border-radius: var(${GLOBAL_STYLE_CONFIG.variable('clear-button', 'border-radius')}, transparent);
    padding: var(${GLOBAL_STYLE_CONFIG.variable('clear-button', 'padding')}, 0);
    line-height: 120%;
    letter-spacing: 0%;
    text-decoration: var(${GLOBAL_STYLE_CONFIG.variable('clear-button', 'text-decoration')}, underline);
    text-decoration-thickness: 0%;
    text-decoration-skip-ink: auto;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: var(${GLOBAL_STYLE_CONFIG.variable('clear-button', 'font-size')}, clamp(14px, 2vw, 18px));
    font-weight: var(${GLOBAL_STYLE_CONFIG.variable('clear-button', 'font-weight')}, 500);
    color: var(${GLOBAL_STYLE_CONFIG.variable('clear-button', 'text-color')},
    ${({theme}) => theme.colors.primary}
    );

    &:hover {
        color: var(${GLOBAL_STYLE_CONFIG.variable('clear-button', 'hover-text-color')},
        ${({theme}) => theme.colors.primaryHover}
        );
        background: var(${GLOBAL_STYLE_CONFIG.variable('clear-button', 'hover-bg-color')},
        transparent
        );
       
    }


`
const FilterActionReset: React.FC<IProps> = ({onResetFilters}) => {
    if (!onResetFilters) return null;
    return (
        <StyledFilterResetBtn onClick={onResetFilters} className={GLOBAL_STYLE_CONFIG.splitByPrefix('clear-button')}>
            Очистить все
        </StyledFilterResetBtn>
    );
};

export default FilterActionReset;